import Vue from 'vue';
import vsNotifications from './index.vue'

const insertBody = (elx, parent) => {
    let bodyx = parent ? parent : document.body
    bodyx.insertBefore(elx, bodyx.firstChild)
}

const NotificationConstructor = Vue.extend(vsNotifications);


let instance;

export default {
    name: 'notify',
    function(parameters) {
        if (parameters.fullWidth) {
            if (parameters.position) {
                parameters.position = parameters.position.replace('right', 'left')
            }
        }

        instance = new NotificationConstructor({
            data: parameters,
        });

        instance.vm = instance.$mount();
        insertBody(instance.vm.$el);
    }
}
